const ru = {
	signIn: 'Войти',
	home: 'Курсы',
	english: 'English',
	russian: 'Русский',
	hey: 'Привет',
	logout: 'Выйти',
	login: 'Войти',
	name: 'Имя',
	firstName: 'Имя',
	lastName: 'Фамилия',
	confirmPassword: 'Подтвердить пароль',
	yourEmail: 'Ваш Email',
	email: 'e-mail',
	password: 'Пароль',
	register: 'Регистрация',
	goToCourse: 'К Заданиям',
	takeThisCourse: 'Взять курс',
	coursesInProgress: 'Курсы в процессе',
	availableCourses: 'Доступные Курсы',
	completedCourses: 'Пройденные курсы',
	noProgressCourses: 'Вы еще не взяли ни одного курса',
	noAvailableCourses: 'Поздравляем! Вы прошли все курсы!',
	noCompletedCourses: 'Вы пока не прошли ни одного курса',
	completeTask: 'Завершить задание',
	completeTaskAndNext: 'Complete task and move to next',
	uncompleteTask: 'Uncomplete task',
	setTaskIncomplete: 'Сделать Задачу Невыполненной',
	replyTo: 'Ответить',
	editComment: 'Редактировать комментарий',
	writeComment: 'Добавить комментарий',
	linkLabel:
		'Ссылка (только с: github.com, codepen.io, jsfiddle.net, codesandbox.io)',
	yourMessage: 'Ваше сообщение',
	whitelistLinksSupport: 'Мы поддерживаем ссылки только с',
	linkIsNotValid: 'Неправильный линк',
	reply: 'Ответить',
	send: 'Послать',
	edit: 'Отредактировать',
	cancel: 'Отмена',
	congrats: 'Поздравляем!',
	completeCourseMessage: 'Вы закончили этот курс!',
	takeAnotherCourse: 'Взять другой курс',
	hint: 'Подсказка',
	articles: 'Статьи',
	practice: 'Практика',
	theory: 'Теория',
	all: 'Все',
	frontend: 'Frontend',
	interview: 'Собеседование',
	yourProgress: 'Ваш прогресс',
	donate: 'Donate',
	requiredField: 'Обязательное поле',
	isInvalid: 'Поле {{fieldName}} не валидно',
	minLengthValidationError: 'Минимальное кол-во символов {{number}}',
	maxLengthValidationError: 'Максимальное кол-во символов {{number}}',
	hasLatinValidationError: 'только латинские буквы',
	hasUpperCaseLetterValidationError: 'заглавную букву',
	hasLowerCaseLetterValidationError: 'букву нижнего регистра',
	hasSpecialCharValidationError: 'специальный символ (!@#$*)',
	hasNumberValidationError: 'число',
	passwordValidationGeneral: 'Должен содержать {{errors}}',
	passwordDoesntMatch: 'Пароль и подтвержденный пароль не одинаковые',
	verificationMessageTitle: 'И последнее... Подтвердите свою учетную запись',
	verificationMessageBody:
		'Пожалуйста, проверьте свою электронную почту, мы отправили вам письмо со ссылкой для активации вашего аккаунта.',
	resendVerificationQuestion: 'Не получили письмо с подтверждением?',
	resendVerificationMessage:
		'Если вы не получили электронное письмо с подтверждением, нажмите здесь, и мы вышлем его вам еще раз.',
	resend: 'Послать снова',
	resendAgain: 'Послать еще раз',
	resendSuccess: 'Мы снова отправили вам ссылку для подтверждения',
	resendLastAttempt:
		'Если вы по-прежнему не можете найти электронное письмо со ссылкой для подтверждения, обратитесь к администратору.',
	activationSuccessTitle: 'Поздравляем!',
	activationSuccessBody:
		'Вы успешно подтвердили свою учетную запись! Удачи на вашем Code Way!',
	activationErrorTitle: 'Ой...',
	activationErrorBody:
		'Что-то пошло не так. Похоже, код подтверждения недействителен или ваш аккаунт уже подтвержден.',
	activationErrorResend: 'Попробуйте отправить инструкции по проверке еще раз.',
	buttonCompleteTask: 'Отметить задачу как выполненную',
	buttonIncompleteTask: 'Отметить задачу как невыполненную',
	passwordRecovery: 'Восстановление пароля',
	emailHasBeenSent: 'Письмо было отправлено.',
	enterEmailForgotPassword:
		'Введите свою почту и мы вышлем вам инструкции для восстановления пароля.',
	emailForgotPasswordInstruction:
		'Мы отправили вам письмо с инструкциями. Пожалуйста, проверьте свою электронную почту.',
	close: 'Закрыть',
	repeat: 'Повторить',
	createNewPassword: 'Создать новый пароль',
	newPasswordSuccessfullyRecovered: 'Ваш новый пароль успешно установлен',
	invalidCredentials: 'Неверный логин или пароль',
	dontHaveAnAccount: 'Нет аккаунта? Зарегестрируйтесь',
	forgotPassword: 'Забыли пароль?',
	inprogress: 'В процессе',
	completed: 'Законченные',
	new: 'Новые',
	noCoursesFound: 'По этому фильтру курсы не найдены.',
	status: 'Статус',
	category: 'Категория',
	clear: 'Очистить',
	markTaskAsCompleted:
		'Поздравляем! Отметьте {{taskName}} задание как выполненное и отправляйтесь к следующим вызовам!',
	taskIsCompleted: 'Поздравляем! Задание {{name}} выполнено!',
	or: 'или',
	and: 'и',
	finishQuizToCompleteTask: 'Пройдите контрольный опрос чтобы закончить задание',
	moreOptionsNeeded: 'Нужно выбрать больше вариантов',
	yourAnswer: 'Ваш ответ',
	prev: 'Предыдущий',
	next: 'Следующий',
	quiz: 'Контрольный опрос',
	youCanDoBetter: 'Вы можете лучше',
	giveTry: 'Попробуйте еще раз',
	youCanDoBetterMore: 'Неплохо! Но вы можете лучше!',
	completeQuizText:
		'Поздравляем! Вы можете завершить задание и двигаться дальше!',
	wellDone: 'Отлично!',
	rightAnswers: 'Правильные ответы',
	checkMistakes: 'Посмотреть ошибки',
	tryAgain: 'Пройти заново',
	copyLinkText: 'Скопируйте линк на ваш код',
	codeWasSaved: 'Код сохранен',
	copy: 'Копировать',
	copied: 'Скопированно',
	myAccount: 'Мой профиль',
	profile: 'Профиль',
	orders: 'Заказы',
	company: 'Компания',
	position: 'Должность',
	emptyInlineTextValue: 'N/A',
	pricing: 'Цены',
	forSubscribersOnly: 'Доступно только для планов {{plans}}',
	taskPlanDemandText:
		'Здорово, что вы уже дошли до этого этапа! Эта задача доступна для планов Standard и PRO. Пожалуйста, выберите свой план и получите доступ к этой задаче :)',
	maxSizeAvatarError:
		'Максимальный размер файла: {{maxSize}}. Размер этого файла: {{actualSize}}.',
	imageTypeError: 'Поддерживаемые форматы изображений: {{allowedExtentions}}',
	free: 'Бесплатный',
	standard: 'Стандартный',
	pro: 'Профессиональный',
	seeAllPlans: 'Все планы',
	subscriptionPlan: 'План подписки',
	subscriptionPlans: 'Планы подписки',
	month: 'Месяц',
	currentPlan: 'Текущий план',
	subscribe: 'Подписаться',
	services: 'Сервисы',
	order: 'Заказать',
	theOrder: 'Заказ',
	moreDetails: 'Подробнее',
	purchase: 'Оплатить',
	currentPosition: 'Текущая позиция',
	desiredPosition: 'Желаемая позиция',
	interviewType: 'Тип интервью',
	technicalInterview: 'Техническое',
	hrInterview: 'HR',
	screeningInterview: 'Скрининг',
	matchingInterview: 'Мэтчинг',
	writeYourQuestions: 'Ваши вопросы',
	fileAttached: 'Файл прикреплен',
	CV: 'Резюме',
	nA: 'н/д',
	upload: 'Добавить',
	remove: 'Удалить',
	removeFile: 'Удалить файл',
	thankYou: 'Спасибо!',
	thankYouOrder: 'Мы рады сообщить, что ваш заказ был получен.',
	thankYouLinkInstructions:
		'Нажмите эту кнопку, чтобы выбрать доступное время для встречи, которое вам наиболее удобно',
	chooseTimeSlot: 'Выберете время',
	afterSchedulingMeetingInfo:
		'После назначения встречи вы получите подтверждение на вашу электронную почту',
	emailDuplcatedThankyou:
		'Мы также отправили вам детали этого заказа на вашу электронную почту со ссылкой для выбора времени встречи',
	lookingForwardToConnecting: 'We look forward to connecting with you!',
	date: 'Дата',
	productName: 'Название продукта',
	price: 'Цена',
	orderNumber: 'Номер заказа',
	orderStatus: 'Статус заказа',
	taskOverview: 'Содержание',
	taskConclusion: 'Теперь вы знаете',
	codeTask: 'Задание с кодом',
	video: 'Видео',
	editPhoto: 'Загрузить фото',
	hello: 'Привет',
	noOrderFound: 'Заказов не найдено.',
	oldPasswordDoesntMatch: 'Старый пароль не правильный',
	changePasswordSuccess: 'Ваш пароль был успешно изменен',
	contactUsFormdSuccess:
		'Спасибо! Мы получили ваше сообщение и вскоре с вами свяжемся.',
	contactUsFormError: 'Что-то пошло не так, попробуйте позже',
	general: 'Общие',
	support: 'Поддержка',
	sales: 'Продажи',
	сontact: 'Контакты',
	contactUs: 'Свяжитесь с нами',
	resizableHint:
		'Нажмите на правый нижний угол и удерживайте, чтобы перетащить и изменить размер',
	gotIt: 'Понятно!',
	accept: 'Принять',
	moreInformation: 'Подробнее',
	replay: 'Ответить',
	delete: 'Удалить',
	runCode: 'Запустить код',
	testCode: 'Тест кода',
	reset: 'Перезагрузить',
	postToComments: 'Опубликовать в комментариях',
	save: 'Сохранить',
	expand: 'Расширить',
	changeView: 'Сменить вид',
	back: 'Назад',
	code: 'Код',
	addLink: 'Добавить ссылку',
	oldPassword: 'Старый пароль',
	newPassword: 'Новый пароль',
	servicesSlogan: 'Ускорь свой успех с помощью наших экспертных услуг',
	subscriptionSlogan:
		'Выбери свой путь к успеху: найди идеальный план для своего путешествия!',
	linkToGithub: 'Ссылка на Github',
	to_courses: 'К курсам',
	console: 'Консоль',
	tests: 'Тесты',
	in_this_lesson: 'В этом уроке:',
	apiControl: 'APIs',
};

export default ru;
